import type {
  GetUserAccessRolesResponse,
  GetGrantedDatabasesResponse,
  GetUserProfileResponse
} from '@gat-ship/types'
import { useGsCloudBackend } from '../../http-client'
import { USER_API_PATHS } from '@gat-ship/types'

export function useUserApiCalls() {
  const { apiGet, apiPut } = useGsCloudBackend()
  /** Retrieve a list of all databases that are accessible to the current authorized user.
   * @returns A promise that resolves to a response containing the list of databases.
   */
  async function getGrantedDatabasesRequest() {
    return await apiGet<GetGrantedDatabasesResponse>(
      USER_API_PATHS.getGrantedDatabases
    )
  }

  /** Retrieves the profile information of the current authorized user.
   * @returns A promise that resolves to a response containing the profile information.
   */
  async function getUserProfileRequest() {
    return await apiGet<GetUserProfileResponse>(USER_API_PATHS.getUserProfile)
  }

  async function invalidateCacheRequest(commandId: string) {
    return await apiPut<undefined>(
      USER_API_PATHS.invalidateCache,
      undefined,
      commandId
    )
  }

  async function getAccessRolesRequest() {
    return await apiGet<GetUserAccessRolesResponse>(
      USER_API_PATHS.getAccessRoles
    )
  }

  async function getUserProfileImageRequest(userId: string) {
    return await apiGet<string>(USER_API_PATHS.getUserProfileImage(userId))
  }

  return {
    getGrantedDatabasesRequest,
    getUserProfileRequest,
    invalidateCacheRequest,
    getAccessRolesRequest,
    getUserProfileImageRequest
  }
}
